import { z } from 'zod';

export const docsColumnSchema = z.object({
  name: z.string(),
  tsName: z.string(),
  dataType: z.string(),
  notNull: z.boolean(),
  primaryKey: z.boolean(),
  default: z.string().nullable(),
});
export type DocsColumn = z.infer<typeof docsColumnSchema>;

export const docsForeignKeySchema = z.object({
  columns: z.array(z.string()),
  referencedTable: z.string(),
  referencedColumns: z.array(z.string()),
  onDelete: z.string().nullable(),
});
export type DocsForeignKey = z.infer<typeof docsForeignKeySchema>;

export const docsIndexSchema = z.object({
  name: z.string(),
  columns: z.array(z.string()),
  isUnique: z.boolean(),
});
export type DocsIndex = z.infer<typeof docsIndexSchema>;

export const docsTableSchema = z.object({
  name: z.string(),
  tsName: z.string(),
  businessRules: z.string().nullable(),
  columns: z.array(docsColumnSchema),
  foreignKeys: z.array(docsForeignKeySchema),
  indexes: z.array(docsIndexSchema),
});
export type DocsTable = z.infer<typeof docsTableSchema>;

export const docsEndpointSchema = z.object({
  method: z.string(),
  path: z.string(),
  summary: z.string().nullable(),
  tags: z.array(z.string()),
  touchesTables: z.array(z.string()),
});
export type DocsEndpoint = z.infer<typeof docsEndpointSchema>;

export const docsDataSchema = z.object({
  tables: z.array(docsTableSchema),
  endpoints: z.array(docsEndpointSchema),
});
export type DocsData = z.infer<typeof docsDataSchema>;
